module.exports = __webpack_public_path__ + "img/footer.8cef07cc.png";